<template>
  <div>
    <breadcrumbs home="Payment Methods" :back="back"/>

    <purtrak-table name="paymentMethods" objectType="payment methods" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="paymentMethods2"
                   fields="id,name,active,creditCard"
                   :listFilters="listFilters"
                   :item-class="paymentMethods => (!paymentMethods.active ? 'grey--text ' : '')"
                   @dblclick="paymentMethods => $router.push({name:'SettingsPaymentMethodsEdit',params:{paymentMethodId:paymentMethods.id}})"
                   title="Payment methods"
                   :print-info="{pageSize:'portrait', subTitle:[]}"
                   download-endpoint="paymentMethodsExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.search='';filters.status='1'">
          <v-list-item>
            <filter-search label="Name" v-model="filters.search"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Status" dense outlined :items="[{value:'2',text:'All'},{value:'1',text:'Active'},{value:'0',text:'Inactive'}]" v-model="filters.status"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.search" close small class="ml-1" @click:close="filters.search=''">Payment method: {{filters.search}}</v-chip>
          <v-chip v-show="filters.status!='1'" close small class="ml-1" @click:close="filters.status='1'">{{filters.status=='0'?'Inactive':'All'}}</v-chip>
        </template>
      </template>
      <template v-slot:menu v-if="!readOnly">
        <v-list-item :to="{name:'SettingsPaymentMethodsEdit'}"><v-list-item-title>Create payment method</v-list-item-title></v-list-item>
        <template v-if="$store.getters.company.connectedToAccounting">
          <v-divider/>
          <v-list-item @click="sync()"><v-list-item-title>Sync payment methods with QBO</v-list-item-title></v-list-item>
        </template>
      </template>

      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'SettingsPaymentMethodsEdit'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}" v-if="!readOnly">
        <v-btn small icon @click.stop="paymentMethod = item;showDelete = true"><v-icon small>mdi-delete</v-icon></v-btn>
      </template>
      <template v-slot:item.name="{item,value,printing}">
        <template v-if="printing">{{value}}</template>
        <template v-else>
          <v-hover v-if="!readOnly" v-slot="{hover}">
            <a @click.stop="$router.push({name:'SettingsPaymentMethodsEdit',params:{paymentMethodId:item.id}})"
                :class="{'text-decoration-underline':hover,'grey--text':!item.active}">{{item.name}}</a>
          </v-hover>
          <div v-else :class="{'grey--text':!item.active}">{{item.name}}</div>
          <div v-if="!item.active" class="grey--text text-caption">Inactive</div>
        </template>
      </template>
      <template v-slot:item.creditCard="{value,printing}">
        <template v-if="printing">{{value?'Y':''}}</template>
        <v-icon v-else-if="value">mdi-check</v-icon>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="paymentMethod.name" @delete="performDelete"/>
  </div>
</template>

<script>

export default {
  name: 'SettingPaymentMethods',
  props: {
    back: {type:Array, required:false}
  },
  data() {
    return {
      filters: {
        status: '1',
        search: ''
      },
      paymentMethod: {},
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true}],
      headers: [{ text: 'NAME', value: 'name', width:'70%',sortable:true},
                { text: 'CREDIT CARD', value:'creditCard', width:'20%', sortable:true,align:'center'},
                { text: '' , value:'action', width:'5%', sortable:false,align:'center'}]
    }
  },
  computed: {
    readOnly() {
      return !this.$store.getters.company.permissions.includes('config.write');
    },
    listFilters() {
      const filters = [];
      if (this.filters.search)
        filters.push({field:'name', comparator:'contains', value:this.filters.search});
      if (this.filters.status != '2')
        filters.push({field:'active', comparator:'eq', value:this.filters.status === '1' ? 'true' : 'false'});
      return filters;
    }
  },
  methods: {
    async performDelete() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SettingPaymentMethods($id:ID!) {
                                                objectDelete(id:$id)
                                              }`,
                                          {id:this.paymentMethod.id});
      this.loading = false;
      if (!results.error) {
        this.$store.commit('setError', {type:'success',message:`Deleted payment method`});
        this.$refs.table?.buildList();
      }
    },
    async sync() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SettingPaymentMethods {
                                             accountingIntegrationSync(step:"paymentMethods") {name}
                                           }`, {});
      if (!results.error) {
        this.$store.commit('setError', {type:'success',message:`Synced payment methods with QBO`});
        this.$refs.table?.buildList();
      }
    }
  }
}
</script>